import { styled, lighten } from '@mui/material/styles';
import { Box, Grid, Paper, Card, CardHeader, ListItem, Button, Typography, TextField } from '@mui/material';

export const HeaderActions = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export const LearnMoreAnchor = styled('a')(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.primary.main,
  textDecoration: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  '&:hover': { textDecoration: 'underline' },
}));

export const InlineLink = styled('a')(({ theme }) => ({
  color: lighten(theme.palette.primary.main, 0.18),
  textDecoration: 'none',
  fontWeight: 500,
  '&:hover': { textDecoration: 'underline', color: theme.palette.primary.main },
}));

export const FullWidthGridItem = styled(Grid)(({ theme }) => ({
  marginTop: 24,
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(2),
  },
}));

export const SkeletonPaper = styled(Paper)({
  padding: 0,
  width: '100%',
});

export const IdpPaper = styled(Box)(({ theme }) => ({
  padding: 0,
  width: '100%',
  overflow: 'hidden',
  border: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[300]}`,
  borderRadius: '5px',
  '& .MuiDivider-root': {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[300],
  },
}));

export const IdpListItem = styled(ListItem)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
}));

export const ScimToggleBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(1),
}));

export const MemberCard = styled(Card)({
  border: 'none',
  boxShadow: 'none',
});

export const HeaderTight = styled(CardHeader)({
  marginTop: 0,
  paddingTop: 0,
});

export const SectionItemGrid = styled(Grid)({
  marginTop: '1rem',
});

export const StrictModeAlertBox = styled(Box)({
  marginBottom: 16,
});

export const ViewScimButton = styled(Button)(({ theme }) => ({
  paddingLeft: 0,
  paddingRight: 0,
  minWidth: 180,
  textTransform: 'none',
  justifyContent: 'flex-start',
  color: theme.palette.primary.main,
  '&:hover': {
    textDecoration: 'underline',
    backgroundColor: 'transparent',
  },
}));

export const RightHint = styled(Typography)({
  textAlign: 'right',
  marginTop: 2,
});

export const FormGridContainer = styled(Grid)({
  width: '100%',
  minWidth: 0,
});

// SCIMSettingsDialog.tsx styles

const SUBSCRIPTION_ELEMENTS_HEIGHT = 53.13;

export const DialogContentRoot = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
}));

export const DialogSection = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const DialogFieldLabel = styled(Typography)({
  fontWeight: 500,
});

export const DialogReadOnlyField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    background: theme.palette.action.disabledBackground,
    opacity: theme.palette.action.disabledOpacity,
    cursor: 'default',
    pointerEvents: 'none',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.action.disabled,
    },
  },
}));

export const DialogTokenActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  '& .MuiCircularProgress-root': {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(1),
  },
}));

export const DialogDropdownButton = styled(Button)(({ theme }) => ({
  height: SUBSCRIPTION_ELEMENTS_HEIGHT,
  justifyContent: 'space-between',
  textTransform: 'none',
  paddingRight: theme.spacing(2),
}));
